<!-- 生日有礼 -->
<template>
  <div class="createPlayStep new-input-box" v-loading="loading">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-button
        type="blue"
        :styleTextObj="{
          width: '44px',
          height: '24px',
          'line-height': '24px',
          padding: '0 8px',
          'min-width': '44px',
        }"
        @click="returnBack()"
        >返回</jd-button
      >
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div :class="{ formBox: localStepNum != 99 }">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <!-- <el-step title="活动模板"></el-step> -->
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 选中活动模板 -->
      <div class="firststep" v-if="localStepNum == 99">
        <div class="activeEdit_bottom">
          <div class="template">
            <div style="width: 82px; padding-top: 5px">模板类型：</div>
            <div class="template-nav">
              <div
                class="template-wz pointer"
                @click="handleNav(item, index)"
                v-for="(item, index) in tempSwitchList"
                :key="item.id"
                :class="{ activeTem: index == tabActive }"
                v-show="item.isVisible"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <!-- m模板图 -->
          <div class="templateBox">
            <!-- 定制 -->
            <div class="temImg">
              <div class="temImg_content" @click="handleOpen()" style="border: 1px solid #D4E2FF;">
                <div class="temImg_content_img temImg_dz">
                  <div class="temImg_dz_center">
                    <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/dz.svg" alt="" />
                    <span>品牌定制</span>
                  </div>
                </div>
                <div class="temImg_content_wz" style="background: #EAF1FF;"></div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow" style="height:432px;border-radius: 8px;" @click="handleOpen()">
                <div class="temImg_content_bgshadow_codeDZ">
                  <img style="width:100%" src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/wximg.png" alt="">
                </div>
              </div>
            </div>
            <!-- 模板 -->
            <div
              class="temImg"
              v-for="(item, index) in giftList"
              :key="item.id"
            >
              <div class="temImg_content">
                <div class="temImg_content_img">
                  <img
                    class="imgs"
                    style="width: 100%"
                    :src="item.imageUrl"
                    alt=""
                  />
                  <img
                    v-if="item.days"
                    class="temImg_content_img_free"
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/common/free.svg"
                    alt=""
                    srcset=""
                  />
                  <div v-if="item.days" class="temImg_content_img_time">
                    倒计时：{{ item.days }}
                  </div>
                </div>
                <div class="temImg_content_wz">
                  <span class="temImg_title">{{ item.imageName }}</span>
                  <span class="temImg_desc">模板ID：{{ item.id }}</span>
                </div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow">
                <div
                  class="temImg_content_bgshadow_code qrCodeIMG"
                  id="queryId"
                  ref="queryId"
                ></div>
                <div class="temImg_content_bgshadow_codeDesc">
                  手机扫码预览模板
                </div>
                <div
                  class="temImg_content_bgshadow_btn pointer"
                  @click="nextStepKai(index + 1, item.id)"
                >
                  使用此模板
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 0">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="backgroundForm"
          label-width="140px"
        >
          <informationForm
            v-model="ruleForm"
            @selectPeopleSure="selectPeopleSure"
            @checkLevelChangeBack="checkListchange"
            :defaultActMember.sync="actMember"
            :peopleSelected.sync="peopleSelected"
            :defaultActivityStartTime.sync="activityStartTime" 
            :defaultActivityEndTime.sync="activityEndTime" 
            :plusObject.sync="ruleDto.plusObject" 
            :isCheckOpenCardTime.sync="ruleDto.isCheckOpenCardTime" 
            :openCardStartTime.sync="ruleDto.openCardStartTime" 
            :openCardEndTime.sync="ruleDto.openCardEndTime" 
            :disabled="activityData.isStart" 
            :needNonMember="true" 
            :activityId="activityData.id" 
            :isShowParterRadio="true"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          />
          <el-form-item label="领奖有效期:" required>
            <el-select size="small" v-model="ruleForm.timeType" :disabled="activityData.isStart || backgroundOpacity">
              <el-option
                v-for="item in brithdayList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户生日信息获取:" required>
            <el-radio-group v-model="ruleDto.birthdayInfoType" :disabled="activityData.isStart || backgroundOpacity">
              <el-radio :label="1">用户填写</el-radio>
              <el-radio :label="2">
                  <span>自动获取</span>
                  <el-tooltip
                    class="item"
                    effect="light"
                    content="获取用户入会时所填写的生日信息，如无生日信息依旧需用户进行手动填写生日信息。"
                    placement="bottom"
                  >
                    <i style="color: #ccc;margin-left: 12px;" class="el-icon-question"></i>
                  </el-tooltip>
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <jd-title label='奖品设置' type="bold"></jd-title>
          <el-form-item label="生日领奖限制:" required>
            <el-radio-group v-model="birthdayReceiveLimitType" @change="changeBirthdayReceiveLimitType">
              <el-radio :label="0">不限制（符合条件可{{ruleDto.activityMode == 0 ? '领奖' : '抽奖'}}）</el-radio>
              <el-radio :label="1">限制</el-radio>
            </el-radio-group>
            <div>
              <el-radio-group class="birthday_receive_limit" v-if="birthdayReceiveLimitType==1" v-model="ruleDto.birthdayReceiveLimitType" @change="changeBirthdayDate">
                <el-radio :label="1" class="mt12">
                  <span>首次提交生日信息在</span>
                  <div class="my_select_time ml12">
                    <el-date-picker prefix-icon="no_icon" v-model="ruleDto.birthdayReceiveLimitStartDate"  type="date" placeholder="开始日期"
                        size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                        style="width: 185px; font-size: 12px" class="time1"
                        :clearable="false" 
                        :disabled="ruleDto.birthdayReceiveLimitType==2">
                    </el-date-picker>
                    <div class="time_to_text">至</div>
                    <!--  -->
                    <el-date-picker prefix-icon="no_icon" v-model="ruleDto.birthdayReceiveLimitEndDate" type="date" placeholder="结束日期"
                        size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                        style="width: 200px; font-size: 12px" class="time2"
                        :clearable="false" 
                        :disabled="ruleDto.birthdayReceiveLimitType==2">
                    </el-date-picker>
                    <i class="el-icon-circle-close date_icon1" v-if="!activityData.isStart" @click="clearBirthdayTime()"></i>
                    <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg" alt=""
                        class="date_icon2" />
                </div>
                </el-radio>
                <el-radio :label="2" class="mt12">
                  首次提交生日信息，且在领奖有效期内不可{{ruleDto.activityMode == 0 ? '领奖' : '抽奖'}}
                </el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
          <el-form-item label="领奖模式:" required>
            <el-radio-group v-model="ruleDto.activityMode" :disabled="activityData.isStart" @change="handleChangeActivityMode">
              <el-radio :label="0">登记领奖模式</el-radio>
              <el-radio :label="1">
                <span>许愿抽奖模式</span>
                <el-popover placement="right" width="600" trigger="hover">
                  <el-image
                    style="width: 100%"
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/mode-wish.png"
                    :preview-src-list="['https://cdn-image.yucrm.cn/images/jd-front-platform/images/mode-wish.png']"
                  >
                  </el-image>
                  <span slot="reference">
                    <jd-button type="blueText" class="ml12">领奖模式说明</jd-button>
                  </span>
                </el-popover>
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="ruleDto.activityMode==0">
            <el-form-item required>
              <span slot="label" class="set">奖品设置:</span>
              <div class="setting-tip">
                <div>
                  <span
                    >1、活动期内，生日会员有机会获得礼品，每个自然年只能领取一次。如果在本自然年领取过生日礼包的会员则无法在其他生日礼包活动领取礼包</span
                  >
                </div>
                <div>
                  <span
                    >2、奖品展示图片建议尺寸：300*300像素，图片大小不能超过300K，类型：JPG、PNG</span
                  >
                </div>
                <div class="setting-tip-last-wrap">
                  <span
                    >3、设置多个奖品时，生日会员可同时领取多个奖品，当设置不同份数奖品时，实际领取情况说明：<br /><span
                      class="setting-tip-red"
                      >例：设置积分发放份数为100份，京豆发放份数为20份。则活动开始后前20名领取的会员可同时收到两份奖品，之后参与的80人只能收到积分奖品</span
                    ></span
                  >
                </div>
              </div>
              <div class="setting-radio">
                <el-radio v-model="ruleForm.settingType" :label="1" :disabled="activityData.isStart || backgroundOpacity"
                  >按等级设置</el-radio
                >
                <el-radio v-model="ruleForm.settingType" :label="2" :disabled="activityData.isStart || backgroundOpacity"
                  >统一设置</el-radio
                >
              </div>
              <div v-if="ruleForm.settingType == 1">
                <div class="setting-level">
                  <div
                    :class="[
                      'setting-level-item',
                      { 'setting-level-item__active': levelIndex == index },
                    ]"
                    v-for="(item, index) in getChooseLevel"
                    :key="index"
                    @click="levelClick(index)"
                  >
                    <span>{{ item.name }}</span>
                  </div>
                </div>
                <div v-for="(item, index) in prizeSettingListLevel" :key="index">
                  <div>
                    <jd-table
                      v-if="levelIndex == index"
                      :tableData="item.settingList"
                      style="width: 1200px;"
                    >
                      <el-table-column prop="date" label="序号" width="110">
                        <template slot-scope="scope">
                          <span>{{ scope.$index + 1 }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="奖品类型" width="200">
                        <template slot-scope="scope">
                          <div>
                            <jd-button
                              type="blueText"
                              :disabled="activityData.isStart || backgroundOpacity"
                              @click="centerVis(scope.row)"
                            >
                              <div v-if="scope.row.prizeType">
                                <span v-if="scope.row.prizeType == 3">
                                  {{scope.row.title}}
                                </span>
                                <span v-else>
                                  {{scope.row.prizeType | prizeType(venderType)}}
                                </span>
                              </div>
                              <div v-else>
                                <span>选奖品</span>
                              </div>
                            </jd-button>
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column label="值" width="80" prop="price">
                      </el-table-column>

                      <el-table-column label="奖品总份数" width="180">
                        <template slot-scope="scope">
                          <el-input
                            v-model.number="scope.row.totalAmount"
                            @input.native="
                              (e) =>
                                (scope.row.totalAmount = checkputn(
                                  e,
                                  scope.row,
                                  'jindou'
                                ))
                            "
                            placeholder="请输入..."
                            @input="
                              (scope.row.totalAmount = getNumberData(
                                1,
                                $event,
                                0,
                                1
                              )),
                                prizeNum(scope.row)
                            "
                            @blur="beAdd(scope.row)"
                            :disabled="backgroundOpacity || activityData.isStart"
                          ></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column label="每日发放限额" width="120">
                        <template slot-scope="scope">
                          <dailyLimitConfig
                            :row="scope.row"
                            :backgroundOpacity="backgroundOpacity"
                            :limitBtnDisabled="backgroundOpacity"
                          ></dailyLimitConfig>
                        </template>
                      </el-table-column>
                      <el-table-column label="奖品展示图片" width="170">
                        <template slot-scope="scope">
                          <el-image class="elImg" :src="scope.row.logo" fit="contain" style="width:40px;height: 40px;background: #D9D9D9;border-radius: 4px 4px 4px 4px;">
                            <div slot="error" class="image-slot">
                            </div>
                          </el-image>
                        </template>
                      </el-table-column>

                      <el-table-column label="操作">
                        <template slot-scope="scope">
                          <div class="btn-wrap">
                            <el-upload
                              :disabled="activityData.isStart || backgroundOpacity"
                              class="upload"
                              action="/jd-hd-web/image/upload"
                              :show-file-list="false"
                              :before-upload="beforeUpload2"
                              :on-success="
                                (file) => {
                                  return handleUpload2(file, scope);
                                }
                              "
                            >
                              <div class="s" style="margin-right: 10px">
                                上传图片
                              </div>
                            </el-upload>
                            <span
                              v-if="scope.row.prizeType != 3"
                              class="s"
                              style="margin-right: 10px"
                              @click="cleanData(scope.row)"
                              >重置</span
                            >
                          </div>
                          <div class="del_box" v-if="!activityData.isStart && !backgroundOpacity">
                            <div class="delQx" @click="deleteSetting(scope.$index, item)">
                              <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/btn_del.svg" alt="" />
                            </div>
                          </div>
                          <jd-button type="blueText" v-if="activityData.isStart && scope.row.title"
                            @click="itemAddNum('',scope.$index)">增加奖品数量</jd-button>
                        </template>
                      </el-table-column>
                    </jd-table>
                    <jd-button
                      class="margin-t16"
                      v-if="levelIndex == index && !activityData.isStart  && !backgroundOpacity"
                      @click="addSetting(item)"
                      type="blue"
                    >
                      添加奖项（{{ item.settingList.length }}/4）
                    </jd-button>
                  </div>
                </div>
              </div>
              <div v-else>
                <jd-table
                  :tableData="prizeSettingList"
                  style="width: 1000px;"
                >
                  <el-table-column prop="date" label="序号" width="110">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 1 }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="奖品类型">
                    <template slot-scope="scope">
                      <div>
                        <jd-button
                          type="blueText"
                          :disabled="activityData.isStart || backgroundOpacity"
                          @click="centerVis(scope.row)"
                        >
                          <div v-if="scope.row.prizeType">
                            <span v-if="scope.row.prizeType == 3">
                              {{scope.row.title}}
                            </span>
                            <span v-else>
                              {{scope.row.prizeType | prizeType(venderType)}}
                            </span>
                          </div>
                          <div v-else>
                            <span>选奖品</span>
                          </div>
                        </jd-button>
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column label="值" width="80" prop="price">
                  </el-table-column>

                  <el-table-column label="奖品总份数" width="180">
                    <template slot-scope="scope">
                      <el-input
                        v-model.number="scope.row.totalAmount"
                        @input.native="
                          (e) =>
                            (scope.row.totalAmount = checkputn(
                              e,
                              scope.row,
                              'jindou'
                            ))
                        "
                        placeholder="请输入..."
                        @input="
                          (scope.row.totalAmount = getNumberData(
                            1,
                            $event,
                            0,
                            1
                          )),
                            prizeNum(scope.row)
                        "
                        @blur="beAdd(scope.row)"
                        :disabled="backgroundOpacity || activityData.isStart"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="每日发放限额" width="120">
                    <template slot-scope="scope">
                      <dailyLimitConfig
                        :row="scope.row"
                        :backgroundOpacity="backgroundOpacity"
                        :limitBtnDisabled="backgroundOpacity"
                      ></dailyLimitConfig>
                    </template>
                  </el-table-column>
                  <el-table-column label="奖品展示图片" width="170">
                    <template slot-scope="scope">
                      <el-image class="elImg" :src="scope.row.logo" fit="contain" style="width:40px;height: 40px;background: #D9D9D9;border-radius: 4px 4px 4px 4px;">
                        <div slot="error" class="image-slot">
                        </div>
                      </el-image>
                    </template>
                  </el-table-column>

                  <el-table-column label="操作" :width="220">
                    <template slot-scope="scope">
                      <div class="btn-wrap">
                        <el-upload
                          :disabled="activityData.isStart || backgroundOpacity"
                          class="upload"
                          action="/jd-hd-web/image/upload"
                          :show-file-list="false"
                          :before-upload="beforeUpload2"
                          :on-success="
                            (file) => {
                              return handleUpload2(file, scope);
                            }
                          "
                        >
                          <jd-button type="blueText" class="s" style="margin-right: 10px">上传图片</jd-button>
                        </el-upload>
                        <jd-button
                          v-if="scope.row.prizeType != 3"
                          type="blueText"
                          style="margin-right: 10px"
                          @click="cleanData(scope.row)"
                          >重置</jd-button
                        >
                        <div class="del_box" v-if="!activityData.isStart && !backgroundOpacity">
                          <div class="delQx" @click="deleteSetting(scope.$index)">
                            <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/btn_del.svg" alt="" />
                          </div>
                        </div>
                        <jd-button type="blueText" v-if="activityData.isStart && scope.row.title"
                          @click="itemAddNum('prizeSettingList',scope.$index)">增加奖品数量</jd-button>
                      </div>
                    </template>
                  </el-table-column>
                </jd-table>
                <jd-button type="blue" @click="addSettingAll" v-if="!activityData.isStart && !backgroundOpacity" class="margin-t16">
                  添加奖项（{{ prizeSettingList.length }}/4）
                </jd-button>
              </div>
            </el-form-item>
          </div>
          <div v-else>
            <el-form-item label="许愿赠送收集次数:" required>
              <el-input
              class="input-style"
                v-model="ruleDto.collectNum"
                placeholder="请输入"
                @input="ruleDto.collectNum = getNumberData(
                    1,
                    $event,
                    0,
                    1,
                    999999
                  )"
              ></el-input>
              <span class="text-style">次收集机会</span>
              <span class="tip-color">*用户完成许愿后，将获得对应次数的心愿礼品收集机会，可用于收集心愿礼品并放入生日奖池参与抽奖</span>
            </el-form-item>
            <el-form-item label="心愿收集任务:" required>
              <taskComponent
                :taskList.sync="taskDataList"
                :taskOrders.sync="taskOrderList"
                :copySteList.sync="taskLevelList"
                :mainText="mainText"
                :isShowUnit="false"
                :isTrueEdit="true"
                :isDisabled="true"
                :extraText="extraText"
                :activityData="activityData"
                :activityStartTime="activityStartTime"
                :activityEndTime="activityEndTime"
                :hasSelectGoods="hasSelectGoods"
              />
            </el-form-item>
            <el-form-item label="生日心愿礼品设置:" required>
              <lotteryPrize
                isShowLimit
                dailyLimitDisabled
                :prizeSettingList.sync="giftSettingList"
                :activityData="activityData"
                :valueRow="valueRow"
                :backgroundOpacity="backgroundOpacity"
                :isDisabled="activityData.isStart"
                :isShowIndex="true"
                :isShowLottery="false"
                :isShowAddBtn="true"
                :isShowMoveBtn="true"
                :isCustomizeTip="true"
                :isShowDeleteBtn="true"
                :actType="39"
                :actEndTime="ruleForm.endTime"
                @addPrizeSetting="addGiftSettingList"
              >
              <template #tipText>
                <div>
                  生日礼包默认开启100%中奖逻辑，相关规则要求如下：
                </div>
                <div>
                  1. 奖项数量：需配置5-20个奖项（最少5个，最多20个）；
                </div>
                <div>
                  2. 概率配置：<span class="red-text">每个奖品中奖概率不可为0%，</span> 因用户完成收集任务后可自主选品放入生日奖池，系统无法提前预判奖池构成；
                </div>
                <div>
                  3. 奖池库存及概率调整：用户奖池中若部分奖品库存为空，<span class="red-text">系统将自动等比放大其余有库存奖品的中奖概率，总概率保持100%，保障100%中奖；若奖池中所有奖品库存均为空，用户抽奖时将提示：所有奖品已经被抢光啦！</span>
                </div>
              </template>
              </lotteryPrize>
            </el-form-item>
            <el-form-item label="是否开启兜底奖品设置:" label-width="1" required>
              <el-radio-group
                v-model="ruleDto.isOpenPocket"
                :disabled="activityData.isStart"
              >
                <el-radio :label="1">开启</el-radio>
                <el-radio :label="0">不开启</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="兜底奖品设置:" required v-if="ruleDto.isOpenPocket==1">
              <span class="red-text">开启后，用户满足抽取生日奖池条件，但奖池全部奖品暂无剩余库存后，会分配兜底奖品，若兜底奖品库存也为空，系统则会提示奖品已抢光。</span>
              <newPrizeTable
                  :prizeList.sync="prizeList"
                  :isDisabled="activityData.isStart"
                  :tableInfo="tableInfo"
                  :valueRow="valueRow"
                  :isShowUpLoadBtn="true"
                  :isShowReset="true"
                  :actType="39"
                  :actEndTime="ruleForm.endTime"
                ></newPrizeTable>
            </el-form-item>
            <jd-title label="配置项设置:" type="bold"></jd-title>
            <el-form-item label="生日许愿标题:" required>
              <div class="setting-box">
               <div class="flex-spc-x">
                  <span class="tip-color">此处为预置生日心愿，用户许愿时可从以下文案中选择 1 条作为心愿，也可自定义愿望。</span>
                  <el-popover placement="right" width="270" trigger="hover">
                    <el-image
                      style="width: 100%"
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/signal-wish.png"
                      :preview-src-list="[
                        'https://cdn-image.yucrm.cn/images/jd-front-platform/images/signal-wish.png',
                      ]"
                    />
                    <jd-button slot="reference" type="blueText">小程序端示意图</jd-button>
                  </el-popover>
               </div>
                <jd-table
                :tableData="wishSetting"
                :tableInfo="wishTableInfo"
                :isIndex="true"
                :indexWidth="70"
                >
                <template #wishNameSlot="{ row }">
                  <el-input
                    v-model.number="row.wishName"
                    placeholder="请输入"
                    maxlength="12"
                    show-word-limit
                  ></el-input>
                </template>
                <template #operationSlot="{ row, rowIndex }">
                  <jd-button type="blueText" v-if="rowIndex != 0" @click="upWishSetting(rowIndex)">上移</jd-button>
                  <jd-button type="blueText" v-if="rowIndex != wishSetting.length - 1" @click="downWishSetting(rowIndex)">下移</jd-button>
                  <jd-button type="blueText" v-if="wishSetting.length > 3" @click="deleteWishSetting(rowIndex)">删除</jd-button>
                </template>
                </jd-table>
                <div class="mt12">
                  <jd-button type="blue" @click="addWishSetting">添加心愿（{{wishSetting.length}}/30）</jd-button>
                  <jd-button type="blueText" @click="resetWishSetting">重置</jd-button>
                </div>
              </div>
            </el-form-item>
          </div>
          <el-form-item label="祝福文案设置:" :required="isShowWin">
            <div style="width: 570px">
              <el-input
                :disabled="backgroundOpacity"
                type="textarea"
                class="textarea"
                style="width: 543px"
                resize="none"
                :maxlength="isShowWin ? 40 : 200"
                show-word-limit
                v-model="ruleForm.blessingText"
              ></el-input>
            </div>
          </el-form-item>
          <activityPageSettings 
            isShowShopName
            isShowMoreSet
            v-model="customerPaperwork"
            :isNeedCustomerPaperworkData="isShowWin"
            themeTitle="主题"
            :giftList="commonTemplateList"
            :templateId="templateId"
            :cusTemplateJSON.sync="ruleDto.cusTemplateJSON"
            :isCustomPreview="isShowWin"
            :isShowDesignNumber="!isShowWin"
            :widthNumber="750"
            :heightNumber="heightNumber"
            templatekey="imageUrl"
            previewKey="imageUrl"
            @selectTemplate="nextStepKai"
            :defaultRgb="currrentRgb2"
            :downloadTemplateUrl="downloadTemplateUrl"
            :designSpecificationsUrl="designSpecificationsUrl"
          >
            <template #customPreview>
              <birthdayGiftDialogNew
                :ruleForm="ruleForm"
                :backgroundImage="backgroundImage"
                :customerPaperwork="customerPaperwork"
                :templateObj="templateObj"
                :prizeSettingList="giftSettingList"
              ></birthdayGiftDialogNew>
            </template>
            <template #otherSet>
              <div v-if="ruleDto.activityMode==1">
                <el-form-item label="按钮设置:">
                  <div class="btn-bg">
                    <el-form-item label="按钮背景图:" label-width="120px">
                      <div class="buttonGroup">
                        <el-upload
                          class="upload"
                          action="/jd-hd-web/image/upload"
                          :show-file-list="false"
                          :before-upload="(file) => beforeUploadUI(file, 1)"
                          :on-success="(res) => handleUploadUI(res, 1)"
                        >
                          <div v-if="customerPaperwork.url3">
                            <img
                              :src="customerPaperwork.url3"
                              style="width: 191px; height: auto"
                            />
                          </div>
                          <jd-button
                            v-else
                            type="blueText"
                            label="自定义上传"
                            :disabled="backgroundOpacity"
                          ></jd-button>
                        </el-upload>
                        <jd-button
                          type="blueText"
                          @click="customerPaperwork.url3 = ''"
                          style="margin: 0 12px 0 12px"
                          :disabled="backgroundOpacity"
                          >重置</jd-button
                        >
                        <span class="color-style">尺寸建议：482*100px</span>
                      </div>
                    </el-form-item>
                    <el-form-item label="按钮文字颜色:" label-width="120px">
                      <div class="buttonGroup">
                        <el-color-picker
                          v-model="customerPaperwork.rgb"
                          size="small"
                        ></el-color-picker>
                        <jd-button
                          type="blueText"
                          class="ml12"
                          @click="customerPaperwork.rgb = currrentRgb"
                          :disabled="backgroundOpacity"
                          >重置</jd-button
                        >
                      </div>
                    </el-form-item>
                  </div>
                </el-form-item>
                <el-form-item label="更换banner海报:">
                  <div class="buttonGroup">
                    <el-upload
                      class="upload"
                      action="/jd-hd-web/image/upload"
                      :show-file-list="false"
                      :before-upload="(file) => beforeUploadUI(file, 2)"
                      :on-success="(res) => handleUploadUI(res, 2)"
                    >
                      <div v-if="customerPaperwork.url2">
                        <img
                          :src="customerPaperwork.url2"
                          style="width: 270px; height: auto"
                        />
                      </div>
                      <jd-button
                        v-else
                        type="blueText"
                        label="自定义上传"
                        :disabled="backgroundOpacity"
                      ></jd-button>
                    </el-upload>
                    <jd-button
                      type="blueText"
                      @click="customerPaperwork.url2 = ''"
                      style="margin: 0 12px 0 12px"
                      :disabled="backgroundOpacity"
                      >重置</jd-button
                    >
                    <span class="color-style">尺寸建议：540*300px</span>
                  </div>
                </el-form-item>
                <el-form-item label="音效配置:" required>
                  <el-radio-group v-model="customerPaperwork.rgb4">
                    <el-radio label="1">开启</el-radio>
                    <el-radio label="2">不开启</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="音效按钮:" required v-if="customerPaperwork.rgb4 == '1'">
                  <el-radio-group v-model="customerPaperwork.rgb3">
                    <el-radio label="2">白色</el-radio>
                    <el-radio label="1">灰色</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </template>
          </activityPageSettings>
          <exposureList 
            v-model="itemListFor"
            :isLimit="true"
            :defaultExposureSwitch.sync="ruleForm.exposureSwitch"
          />
          <sharFrom 
            v-model="ruleForm"
            :sharePic="sharePic"
          />
          <activityRules 
            v-model="ruleForm.ruleDescription"
            :isForceRemind.sync="ruleDto.isForceRemind"
            :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition"
            :activityData="activityData"
            :valueRow="valueRow"
            @generateRule="generateRule"
          />
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum != 99">
      <jd-button
        v-show="!itemId && backgroundOpacity"
        @click="clickLocalStep()"
        style="margin-right: 8px"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn">保存至草稿箱</jd-button>
      <template v-if="!backgroundOpacity">
        <jd-button
          v-show="!itemId"
          v-if="isSave"
          @click="resetForm"
          v-preventReClick
          type="blue"
          >保存设置</jd-button
        >
      </template>

      <jd-button
        v-show="itemId"
        size="medium"
        @click="cancelEdit"
        style="margin-right: 8px"
        >取消</jd-button
      >
      <jd-button v-show="itemId" type="blue"
        >保存设置</jd-button
      >
    </div>

    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
      :disabled="backgroundOpacity"
    ></selectGoodsMonitor>

    <!-- 选择奖品弹窗 -->
    <selectProduct
      ref="selectProduct"
      v-if="isSelectProduct"
      :echoDate="echoDate"
      :actId="valueRow"
      :num="1"
      :JingdouCount="JingdouCount"
      :actType="39"
      :actEndTime="ruleForm.endTime"
      @choose-shop="getTheData"
      @close="productClose"
    >
    </selectProduct>

    <!-- 增加奖品弹窗 -->
    <addPrizeNum :isShowAddNum="isShowAddNum" :prizeData="toAddItem" @confirm="confirmAdd" @close="isShowAddNum=false"/>

    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 领奖模式说明弹窗 -->
    <el-dialog
        title="领奖模式说明"
        :visible.sync="isShowMode"
        width="800px"
      >  
      <div>
        <div class="award-text">
         {{ awardModeText }}
        </div>
        <img style="width: 760px;object-fit: cover;" :src="awardModeUrl"/>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import informationForm from "./components/informationForm.vue"
import activityPageSettings from "./components/activityPageSettings.vue"
import exposureList from "./components/exposureList.vue"
import sharFrom from "./components/sharFrom.vue"
import activityRules from "./components/activityRules.vue"
import selectProduct from "./select_product_componentization.vue";
import QRCode from "qrcodejs2";
import {
  createBirthDayGift,
  updateBirthDayGift,
  getBirthDayDetail,
  hdTaskTemplateGroup,
  sellerImage,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import draggable from "vuedraggable";

import { uploadpic } from "@/api/jhk/paradiseAndTaskCommonController.js";
const shareIcon = 'https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/common/birthDay.png'
import addPrizeNum from "./components/add-prize-num.vue";
import taskComponent from "./components/_components/taskComponent.vue";
import lotteryPrize from "./components/lotteryPrize/index.vue";
import newPrizeTable from "./components/newPrizeTable/index.vue";
import birthdayGiftDialogNew from "./components/newActPreviews/birthdayGiftDialogNew.vue";
import {
  conditionValue,
  getTaskTypeOptions,
} from "./components/taskCommonField/index.js";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
import dailyLimitConfig from "@/views/interactiveMarketing/activity/components/dailyLimitConfig.vue";
import {
  useInputTaskData,
  useOutputTaskData,
} from "./components/commDataHook/useTaskData.js";
import { useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";
export default {
  components: {
    selectProduct,
    selectGoodsMonitor,
    draggable,
    addPrizeNum,
    informationForm,
    activityPageSettings,
    exposureList,
    sharFrom,
    activityRules,
    taskComponent,
    lotteryPrize,
    newPrizeTable,
    birthdayGiftDialogNew,
    dailyLimitConfig,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    ids: {
      type: String,
      default: "",
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    }
  },
  computed:{
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    // 获取选中的会员
    getChooseLevel(){
      if(this.ruleForm.partner.includes("-1")){
        return this.levelList
      }else{
        return this.levelList.filter(item=>this.ruleForm.partner.includes(item.value))
      }
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn(){
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    awardModeUrl() {
      let urls = {
        0: "",
        1: ""
      }
      return urls[this.ruleDto.activityMode]
    },
    awardModeText() {
      let texts = {
        0: "登记领奖模式：登记生日后，满足领取有效期、自然年未领过生日礼包，即可直接领取；",
        1: "许愿抽奖模式：登记生日后，完成许愿、任务收集心愿礼品，集满生日奖池（5个心愿礼品可合成奖池）；领奖有效期内可参与抽奖。"
      }
      return texts[this.ruleDto.activityMode]
    },
    isShowWin() {
      return this.ruleDto.activityMode == 1
    },
    // 切换模板
    commonTemplateList() {
      let list = this.giftList.filter(
        (item) => item.layout - 1 == this.ruleDto.activityMode
      );
      return list;
    },
    backgroundImage() {
      return this.ruleDto.cusTemplateJSON ? JSON.parse(this.ruleDto.cusTemplateJSON).activityBgImg : this.templateObj.url4
    },
    taskTypeOptions() {
      return getTaskTypeOptions("收集");
    },
    downloadTemplateUrl() {
      return this.ruleDto.activityMode==1 ? 'https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/birth-standard.psd' : null;
    },
    designSpecificationsUrl() {
      return this.ruleDto.activityMode==1 ? 'https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/birth-standard-pre.png' : 'https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/standardSRYL.png'
    },
    heightNumber() {
      return this.ruleDto.activityMode==1 ? 1650 : 2071
    }
  },
  watch: {
    localStepNum(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          this.getCodeIMG();
        });
      } else {
        this.buriedPoint(1, this.activityData.name, "互动管理", "互动活动");
      }
    },
  },
  data() {
    return {
      birthdayReceiveLimitType: 0,
      mainText: "收集机会",
      actMember: "1",
      peopleSelected: [],
      taskLevelList: [],
      copyLevelList: [],
      giftSettingData: [
        {
          index: 0,
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          percentage: null,
          logo: "",
          prizeObjectType: 0
        },
        {
          index: 1,
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          percentage: null,
          logo: "",
          prizeObjectType: 0
        },
        {
          index: 2,
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          percentage: null,
          logo: "",
          prizeObjectType: 0
        },
        {
          index: 3,
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          percentage: null,
          logo: "",
          prizeObjectType: 0
        },
        {
          index: 4,
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          percentage: null,
          logo: "",
          prizeObjectType: 0
        },
      ],
      loading: false,
      isCustomerNull: false,
      conditionValue: conditionValue,
      templateObj: {},
      currrentRgb: "",
      customerPaperwork: {
        title: "生日许愿抽奖",//活动主题
        desc: "",//活动说明
        titleColor: "#FEE7D7",//主题文字颜色
        rgb: "",//按钮文字颜色
        rgb3: "1",  //音效按钮颜色
        rgb4: "1",//音效配置
        url2: "",//banner海报图
        url3: "",//按钮背景图
      },
      wishTableInfo: [
        {
          label: "心愿名称",
          prop: "wishName",
          slot: "wishNameSlot",
          minWidth: 100,
        },
        {
          label: "操作",
          prop: "operation",
          slot: "operationSlot",
        }
      ],
      wishSetting: [
        {
          wishName: "平安喜乐，万事顺遂",
          sort: 0,
        },
        {
          wishName: "愿所有美好，都如期而至",
          sort: 1,
        },
        {
          wishName: "岁岁常欢愉，年年皆胜意",
          sort: 2,
        },
        {
          wishName: "所求皆如愿，所行化坦途",
          sort: 3,
        },
        {
          wishName: "多喜乐，长安宁，岁岁无忧",
          sort: 4,
        },
        {
          wishName: "愿日子清透，万事皆甜",
          sort: 5,
        },
        {
          wishName: "新岁启封，喜乐常伴",
          sort: 6,
        },
        {
          wishName: "岁岁常安康，年年皆欢喜",
          sort: 7,
        },
      ],
      tableInfo: [
        {
          label: "奖品类型",
          prop: "prizeType",
          slot: "prizeTypeSlot",
          minWidth: 100,
        },
        {
          label: "值",
          prop: "price",
          minWidth: 100,
        },
        {
          label: "奖品名称（12字以内）",
          prop: "title",
          slot: "titleSlot",
          slotHead: "titleHeader",
          minWidth: 200,
        },
        {
          label: "奖品数量",
          prop: "totalAmount",
          slot: "totalAmountSlot",
          minWidth: 120,
        },
        {
          label: "图片",
          prop: "logo",
          slot: "logoSlot",
          minWidth: 120,
        },
        {
          label: "操作",
          prop: "operation",
          slot: "operationSlot",
          minWidth: 142,
        },
      ],
      prizeList: [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          singleAmount: "",
          prizeObjectType: 1,
        },
      ],
      giftSettingList: [
        {
          index: 0,
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          percentage: null,
          logo: "",
          prizeObjectType: 0
        },
        {
          index: 1,
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          percentage: null,
          logo: "",
          prizeObjectType: 0
        },
        {
          index: 2,
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          percentage: null,
          logo: "",
          prizeObjectType: 0
        },
        {
          index: 3,
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          percentage: null,
          logo: "",
          prizeObjectType: 0
        },
        {
          index: 4,
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          percentage: null,
          logo: "",
          prizeObjectType: 0
        },
      ],
      extraText: "*用户完成对应任务，可获得心愿礼品收集次数；收集的心愿礼品可放入生日奖池参与抽奖",
      hasSelectGoods: [],
      taskDataList: [],
      taskOrderList: [],
      isShowMode: false,
      actEndTime: "",
      isShowTip: false,
      // 1.14迭代
      ruleDto:{
        isCheckOpenCardTime:false,
        openCardStartTime:'',
        openCardEndTime:'',
        plusObject:0, //plus会员
        cusTemplateJSON: "", // 自定义背景图
        isForceRemind: false, // 是否强制提醒
        birthdayInfoType: 1, // 生日信息获取类型
        activityMode: 0,//领奖模式
        collectNum: "",//收集次数
        isOpenPocket: 1, //是否开启兜底奖品设置
        birthdayReceiveLimitType: 0, //生日领奖限制
        birthdayReceiveLimitStartDate: "",//生日领奖开始时间
        birthdayReceiveLimitEndDate: "",//生日领奖结束时间
      },
      isKeyActivity: 0, // 是否重点活动
      placementPosition: [], // 活动投放位置
      openCardStartTimeOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleDto.openCardEndTime).valueOf() - 24 * 60 * 60 * 1000;
        },
      },
      openCardEndTimeOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < new Date(this.ruleDto.openCardStartTime).valueOf();
        },
      },

      isSelectProduct: false,
      mainImagelist: [],
      templateId: "",
      tabActive: 0,
      navItem: {},
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      giftList: [],
      selectGoodsArr: [],
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      telCode: `https://yq-hd-rc.isvjcloud.com/clientPreview?venderId=${this.$store.state.loginUserInfo.venderId}&activityType=12`,
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: -1,
        },
      ],
      valueRow: null,
      echoDate: {},
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      pickerOptionsValue: {
        disabledDate: (time) => {
          if(this.ruleForm.endTime){
            return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleForm.endTime).valueOf()
          }else{
            return time.getTime() < Date.now() - 8.64e7
          }
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          if(this.ruleForm.startTime){
            return time.getTime() < Date.now() - 8.64e7 || time.getTime() < new Date(this.ruleForm.startTime).valueOf()
          }else{
            return time.getTime() < Date.now() - 8.64e7
          }
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      qrcode: null,
      joinBlackList: false,
      checked: false,
      localStepNum: 0, // 将外部传入的步骤赋值到本地，避免直接更改props
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
        partner: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个",
            trigger: "change",
          },
        ],
        term: [{ required: true, message: "请填写抽奖条件", trigger: "blur" }],
        isLongTime: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        ruleDescription: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
      },
      ruleForm: {
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "", // 参与活动前N天
        openCardFollow: 0, // 开卡入会后方可参与活动
        exposureSwitch: false,
        radio: 0,
        activityName: "",
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "",
        timeType: 'day',
        settingType: 2,
        blessingText: "",
        isValidBlackList: 0,
      },
      sharePic: "",
      activityStartTime: null,
      activityEndTime: null,
      prizeSettingList: [
        {
          prizeType: null,
          price: null,
          totalAmount: null,
          percentage: null,
        },
      ],
      prizeSettingListLevel: [],
      index: 0,
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      fileList: "",
      disableTime: false,

      templateJson: {
        templateUItype: "",
      },

      levelList: [],
      levelIndex: 0,
      brithdayList: [
        {
          label: "生日当天",
          value: 'day',
        },
        {
          label: "生日当周",
          value: 'week',
        },
        {
          label: "生日当月",
          value: 'month',
        },
      ],
      uploadSize:false,
      priceImg:'https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/prizeShow.png',//默认产品图
      itemArr: [],
      isDraft:false,
      toAddItem: null,
      isShowAddNum: false,
      toAddBelong: '',
      toAddIndex: 0,
    };
  },
  filters: {
    prizeType(num,type) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "京东E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "京东PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      } else if (num == "10") {
        result = "礼品品卡";
      } else if (num == "13") {
        result = "令牌";
      } else if (num == "12") {
        result = "专享价";
      } else if (num == "14") {
        result = "实物（随单发）";
      }
      return result;
    },
  },
  async created() {
    console.log("当前玩法id", this.activityData.id);
    this.sharePic = shareIcon;
    this.ruleForm.sharePic = this.sharePic;
    this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleForm.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
    await this.getLevel();
    this.hdTaskTemplateGroup();
  },
  methods: {
    clearBirthdayTime() {
      this.ruleDto.birthdayReceiveLimitStartDate = ""
      this.ruleDto.birthdayReceiveLimitEndDate = ""
    },
    changeBirthdayDate() {
      this.ruleDto.birthdayReceiveLimitStartDate = ""
      this.ruleDto.birthdayReceiveLimitEndDate = ""
    },
    changeBirthdayReceiveLimitType(val) {
      this.changeBirthdayDate()
      if(val==1) {
        this.ruleDto.birthdayReceiveLimitType = 1;
      } else {
        this.ruleDto.birthdayReceiveLimitType = 0;
      }
    },
    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
    },
    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let type = file.name
          .substring(file.name.lastIndexOf("."))
          .toLowerCase();
        let sorts = [".png", ".jpg"];
        if (sorts.indexOf(type) < 0) {
          reject();
          this.$message.info("所选图片格式不符，请重新选择");
        } else {
          let image = new Image();
          let _URL = window.URL || window.webkitURL;
          image.onload = function () {
            const valid = image.width == width && image.height == height;
            file.isFlag = valid;
            if (valid) {
              resolve(true);
            } else {
              _this.$message.info("图片尺寸不符合要求，请重新上传");
              reject();
            }
          };
          image.src = _URL.createObjectURL(file);
        }
      });
    },
    // 背景图上传校验
    async beforeUploadUI(file, type) {
      let sizeype = {
        1: {
          width: 482,
          height: 100,
        },
        2: {
          width: 540,
          height: 300,
        },
      };
      const status = await this.imgchecked(
        file,
        sizeype[type].width,
        sizeype[type].height
      );
      if (!status) {
        return false;
      }
    },
    // 背景图上传图片
    handleUploadUI(res, type) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        if (type == 1) {
          this.customerPaperwork.url3 = res.data;
          this.$message.success("按钮背景图上传成功");
        } else if (type == 2) {
          this.customerPaperwork.url2 = res.data;
          this.$message.success("海报上传成功");
        } 
      }
    },
    initCustomizeData(row) {
      this.customerPaperwork.titleColor = row.rgb2;//主题文字颜色
      this.customerPaperwork.rgb = row.rgb;//按钮文字颜色
      this.customerPaperwork.rgb3 = (row.rgb3=='1' ? '2' : '1');//音效按钮颜色
      this.currrentRgb = row.rgb; //重置时使用按钮文字颜色
      this.currrentRgb2 = row.rgb2;//重置时使用主题文字颜色
    },
    handleChangeActivityMode(val){
      if(val==1) {
        this.ruleForm.blessingText = "生日快乐!愿往后岁岁年年,平安喜乐常相伴,日子温柔又闪光,所求皆如愿！"
      } else {
        this.ruleForm.blessingText = ""
      }
      this.ruleForm.settingType = 2;
      this.prizeSettingList = [
        {
          prizeType: null,
          price: null,
          totalAmount: null,
          percentage: null,
        },
      ]
      this.prizeSettingListLevel = this.copyLevelList.map((item) => {
        return {
          customerLevel:String(item.customerLevel),
          name: item.customerLevelName,
          settingList: [
            {
              prizeType: null,
              price: null,
              totalAmount: null,
              percentage: null,
            },
          ],
        };
      });
      this.giftSettingList = this.giftSettingData
      this.ruleDto.isOpenPocket = 1;
      this.prizeList = [{
        assetsId: null, // 资产项id(计划id优惠卷id商品id)
        prizeType: null,
        price: null,
        logo: null,
        title: "",
        totalAmount: null,
        singleAmount: "",
        prizeObjectType: 1,
      }];
      this.wishSetting = [
        {
          wishName: "平安喜乐，万事顺遂",
          sort: 0,
        },
        {
          wishName: "愿所有美好，都如期而至",
          sort: 1,
        },
        {
          wishName: "岁岁常欢愉，年年皆胜意",
          sort: 2,
        },
        {
          wishName: "所求皆如愿，所行化坦途",
          sort: 3,
        },
        {
          wishName: "多喜乐，长安宁，岁岁无忧",
          sort: 4,
        },
        {
          wishName: "愿日子清透，万事皆甜",
          sort: 5,
        },
        {
          wishName: "新岁启封，喜乐常伴",
          sort: 6,
        },
        {
          wishName: "岁岁常安康，年年皆欢喜",
          sort: 7,
        },
      ];
      if(this.commonTemplateList.length>0) {
        this.templateId = this.commonTemplateList[0].id;
        this.templateObj = this.commonTemplateList[0];
        this.initCustomizeData(this.templateObj)
      }
    },
    deleteWishSetting(index) {
      if(this.wishSetting.length<=3) {
        this.$message.error("心愿最少保留3个");
        return
      }
      this.wishSetting.splice(index, 1);
    },
    upWishSetting(index) {
      this.wishSetting[index] = this.wishSetting.splice(
        index - 1,
        1,
        this.wishSetting[index]
      )[0];
    },
    downWishSetting(index) {
      this.wishSetting[index] = this.wishSetting.splice(
        index + 1,
        1,
        this.wishSetting[index]
      )[0];
    },
    addWishSetting() {
      if(this.wishSetting.length >= 30) {
        this.$message.error("心愿最多添加30个");
        return
      }
      this.wishSetting.push({ 
        wishName: "",
        sort: this.wishSetting.length,
      })
    },
    resetWishSetting() {
      let wishTextList = {
        0: "平安喜乐，万事顺遂",
        1: "愿所有美好，都如期而至",
        2: "岁岁常欢愉，年年皆胜意",
        3: "所求皆如愿，所行化坦途",
        4: "多喜乐，长安宁，岁岁无忧",
        5: "愿日子清透，万事皆甜",
        6: "新岁启封，喜乐常伴",
        7: "岁岁常安康，年年皆欢喜"
      }
      this.wishSetting = [
        {
          wishName: "平安喜乐，万事顺遂",
          sort: 0,
        },
        {
          wishName: "愿所有美好，都如期而至",
          sort: 1,
        },
        {
          wishName: "岁岁常欢愉，年年皆胜意",
          sort: 2,
        },
        {
          wishName: "所求皆如愿，所行化坦途",
          sort: 3,
        },
        {
          wishName: "多喜乐，长安宁，岁岁无忧",
          sort: 4,
        },
        {
          wishName: "愿日子清透，万事皆甜",
          sort: 5,
        },
        {
          wishName: "新岁启封，喜乐常伴",
          sort: 6,
        },
        {
          wishName: "岁岁常安康，年年皆欢喜",
          sort: 7,
        }
      ]
    },
    addGiftSettingList() {
      this.giftSettingList.push({
        index: this.giftSettingList.length,
        prizeType: null,
        price: null,
        title: "",
        totalAmount: null,
        percentage: null,
        logo: "",
        prizeObjectType: 0,
      })
    },
    // 点击下单时间显示提示
    orderFocus() {
      if(this.activityData.isStart) {
        this.isShowTip = true
      }
    },
    // 改变数量值
    confirmAdd(num) {
      let {toAddBelong, toAddIndex} = this;
      if(toAddBelong == 'prizeSettingList'){
        this[toAddBelong][toAddIndex].totalAmount = num;
      }else {
        this.prizeSettingListLevel[this.levelIndex].settingList[index].totalAmount = num;
      }
      this.isShowAddNum = false;
    },
    // 获取相关数据打开弹窗
    itemAddNum(arrStr,index) {
      if(arrStr == 'prizeSettingList'){
        this.toAddItem = {
          ...this[arrStr][index],
          num: this[arrStr][index].totalAmount
        };
      }else {
        this.toAddItem = {
          ...this.prizeSettingListLevel[this.levelIndex].settingList[index],
          num: this.prizeSettingListLevel[this.levelIndex].settingList[index].totalAmount
        };
      }
      if( !this.toAddItem.title ) {
        this.$message.error("没有奖品不能设置数量！")
        return
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    // 1.14迭代
    clearNewTime() {
      this.ruleDto.openCardStartTime = "";
      this.ruleDto.openCardEndTime = "";
    },

    inp(val) {
      this.$forceUpdate();
    },
    // 京东计划数量计算
    prizeNum(row) {
      console.log(row);
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8,10].includes(Number(row.prizeType))) {
        if (
          Number(row.totalAmount) &&
          Number(row.totalAmount) > row.budgetRemain
        ) {
          row.totalAmount = "";
          if (row.prizeType == 5)
            this.$message.error(
              "京东E卡总份额数量不能大于该京东E卡剩余预算额！"
            );
          if (row.prizeType == 6)
            this.$message.error(
              "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
            );
          if (row.prizeType == 7)
            this.$message.error(
              "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
            );
          if (row.prizeType == 8)
            this.$message.error(
              "现金红包总份额数量不能大于该现金红包剩余预算额！"
            );
          if (row.prizeType == 10)
            this.$message.error(
              "礼品卡总份额数量不能大于该礼品卡剩余预算额！"
            );
        }
      }
    },
    // 活动进行中修改奖品数量
    beAdd(row) {
      if (this.activityData.isStart) {
        if (row.totalAmount < row.minNum && row.minNum) {
          row.totalAmount = row.minNum;
          this.$message.error("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },
    //上传图片前校验   分享设置
    beforeUpload1(file) {
      let _this = this;
      const isSize = new Promise((resolve, reject) => {
        let width = 200;
        let height = 200;
        var _URL = window.URL || window.webkitURL;
        var img = new Image();
        img.onload = function() {
            let valid = width === this.width  && height === this.height;
            valid ? resolve() : reject(this);
            _this.uploadSize = valid;
        }
        img.src = _URL.createObjectURL(file);
      }).then(()=>{
        return file
      },()=>{
        this.$message.info("图片宽高不符合要求,请重新上传");
        return Promise.reject()
      })
      // 校验尺寸和类型
      const isLt1M = file.size < 1024 * 1024;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      const isType = sorts.includes(type)
      if (!isLt1M) {
        this.$message.info("上传图片大小不能超过 1MB");
      }
      if (!isType) {
        this.$message.info("所选文件格式不符，请重新选择");
      }
      return isLt1M && isType && isSize
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      // console.log(nowDate,startDate);
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }
      // console.log(days);

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    handleNav(item, index) {
      this.tabActive = index;
      this.navItem = item;
      this.getPolite();
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      const { data } = await hdTaskTemplateGroup({
        hdTaskType: this.activityData.id,
      });
      this.tempSwitchList = [
        {
          id: -1,
          groupName: "全部",
          frontHide: false,
        },
        ...data,
      ];
      this.tempSwitchList.map((item) => {
        item.isVisible = true;
        item.title = item.groupName;
      });
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: this.navItem.id == -1 ? "" : this.navItem.id,
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList = data.records.map((item) => {
        return {
          ...item,
          days: item.activityStartTime
            ? this.getDaysBetween(item.activityStartTime, item.activityEndTime)
            : "",
        };
      });
      if(this.ids == "") {
        this.templateId = this.giftList[0].id;
      }
      if(this.templateId) {
        let arr = this.commonTemplateList.filter(
          (item) => item.id == this.templateId
        );
        if(arr.length>0) {
          this.templateObj = arr[0];
          if(this.isCustomerNull) {
            this.initCustomizeData(this.templateObj)
          }
          this.currrentRgb = this.templateObj.rgb;
          this.currrentRgb2 = this.templateObj.rgb2;
        }
      }
      this.pageData.total = data.total * 1;
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },

    //删除
    delec(index) {
      this.mainImagelist.splice(index, 1);
      this.itemListFor.splice(index, 1);
      // console.log(this.selectGoodsArr, 4444444);
    },

    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },

    selectGoodsClose(data) {
      console.log(data, 222);
      if (data) {
        console.log(data);
        this.itemListFor = [];
        this.mainImagelist = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListFor.push(fomeVaule);
          this.mainImagelist.push(fomeVaule);
        });
        console.log(this.mainImagelist);
        this.selectGoodsArr = this.itemListFor;
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsState = false;
    },

    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },

    exposureSwitchChange(val) {
      if (!val) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$forceUpdate();
    },

    nextStepKai(index, templateId = 0,item) {
      console.log(index,templateId,item,'55666');
      this.localStepNum = 0;
      this.templateJson.templateUItype = index+1;
      if (templateId) {
        this.templateId = templateId;
      }
      this.templateObj = item;
      if(this.ruleDto.activityMode==1) {
        this.initCustomizeData(item)
      }

    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push({
              name:item.customerLevelName,
              value:String(item.customerLevel)
            });
          });
          this.copyLevelList = res.data;
          this.prizeSettingListLevel = res.data.map((item) => {
            return {
              customerLevel:String(item.customerLevel),
              name: item.customerLevelName,
              settingList: [
                {
                  prizeType: null,
                  price: null,
                  totalAmount: null,
                  percentage: null,
                },
              ],
            };
          });
          // 获取详情
          this.getDetail(); 
        })
        .catch((res) => {});
    },
    //选中改变
    checkListchange(val) {
      // 重置选中状态
      this.levelIndex = 0
      // 全部
      let levelArr = []
      if(this.ruleForm.partner.includes("-1")){
        levelArr = this.levelList
      }else{
        levelArr = this.levelList.filter(item=>this.ruleForm.partner.includes(item.value))
      }
      this.prizeSettingListLevel = levelArr.map(level=>{
        const index = this.prizeSettingListLevel.findIndex(item=>item.customerLevel == level.value)
        // 已存在
        if(index != -1){
          return this.prizeSettingListLevel[index]
        }else{
          return {
            customerLevel:level.value,
            name: level.name,
            settingList: [
              {
                prizeType: null,
                price: null,
                totalAmount: null,
                percentage: null,
              },
            ],
          };
        }
      })
    },
    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      for (let index = 0; index < codeImg.length; index++) {
        const elementbox = codeImg[index];
        elementbox.innerHTML = "";
      }
      let url = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg="
      // const codeImg = this.$refs[queryIdIMG];
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text:url + this.giftList[index].imageUrl,
        });
      }
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 140, // 设置宽度，单位像素
        height: 140, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //输入框限制负数
    checkputn(e, row = {}, type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        // 不能输入0，绑定的值如果小于1，那么输入框置空
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        if (
          row.quantityTotal &&
          row.price &&
          row.totalAmount &&
          row.prizeType == 2
        ) {
          let numTotal = this.$jingdouTotal({
            ...row,
            prizeCount: row.totalAmount,
          });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return row.totalAmount;
        }
      }
    },
    //上传图片
    handleChange(file, fileList) {
      const isLt3M = file.size < 1024 * 300;
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 300K");
        this.$refs.upload.clearFiles();
      } else {
        this.$refs.upload.$children[1].$el.style.display = "none";
        // this.objectForm.name = file.name;
        let formdata = new FormData();
        formdata.append("file", file.raw);
        uploadpic(formdata).then((res) => {
          // 获取图片真实url
          this.fileList = res.data;
        });
      }
    },
    handleRemove(file, fileList) {
      // this.fileList = [];
      // this.$refs.upload.clearFiles();
      // this.form.logo = "";
      this.$refs.upload.$children[1].$el.style.display = "inline-block";
    },
    // changeImg(row) {
    //   console.log(row, 33333333333);
    // },
    httpRequest() {},
    //生成规则
    generateRule() {
      let limitText = `不限制（符合条件可${this.ruleDto.activityMode == 0 ? '领奖' : '抽奖'}）`
      if(this.ruleDto.birthdayReceiveLimitType==1) {
        limitText = `用户如果首次提交的生日信息是在${this.ruleDto.birthdayReceiveLimitStartDate}~${this.ruleDto.birthdayReceiveLimitEndDate}时间段内，今年将无法${this.ruleDto.activityMode == 0 ? '领奖' : '抽奖'}，需次年参与活动${this.ruleDto.activityMode == 0 ? '领奖' : '抽奖'}`
      } else if(this.ruleDto.birthdayReceiveLimitType==2) {
        limitText= `用户如果是首次提交生日信息，且在领奖有效期内的不可${this.ruleDto.activityMode == 0 ? '领奖' : '抽奖'}；如果是在领奖有效期前已完善过生日信息，且在领奖有效期内，则允许${this.ruleDto.activityMode == 0 ? '领奖' : '抽奖'}`
      }
      let text1 = "\n生日礼奖品:\n",
        text2 = "注意：以上奖品为商家发放的全部心愿礼品，仅为用户可收集奖品范围，不代表用户必然获得其中任意一款；最终能否获得奖品，以生日奖池抽奖结果为准。",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = `\n2.生日礼领取规则：\n（1) 领取条件：符合活动对象身份要求，在领奖有效期内进入活动页按提示操作即可领取生日礼遇；
（2) 每月生日礼数量有限，发完即止，具体数量以当月页面显示为准。
（3) 生日信息提交后一般情况下次月生效；生日信息填写完成后不可修改，请谨慎填写。
（4) 每位会员1年仅可领取1次生日礼遇；
（5）生日领奖限制：${limitText}`,
        text7 = "\n2.许愿抽奖玩法介绍：\n（1）参与许愿：用户在完成生日填写后，可在活动页引导下许下自己的生日愿望。许愿的方式分为两种:(1)直接填写心愿，心愿输入在12字符以内。需注意，您输入的内容不得违反法律法规行政规章的规定、社会主义核心价值观、公序良俗等;(2)选择预设的心愿，您可以通过“换一换”功能挑选更符合您心意的心愿。\n（2）心愿礼品收集:许愿完成后，用户可以通过点击页面上的“收集”按钮，消耗自己的心愿收集机会，每点击一次按钮，即可选择一次心愿礼品。用户可以通过点击“调整奖池”，将当前心愿礼品放入自己的生日抽奖池中。需注意，部分心愿礼品需要先完成对应的心愿收集任务，才能将其放入生日抽奖池。点击商品图上的“收集TA”继续完成任务。只有已经收集成功的心愿礼品，才能放入生日许愿池中。为免疑义，心愿礼品收集玩法说明中所称“收集的心愿礼品”，并不意味着用户已实际获得该礼品，而是获得将该礼品放入生日抽奖池的机会。最终能否获得该奖品，以生日奖池抽奖结果展示为准。\n" +
        "（3）生日抽奖：完成生日许愿后，当用户点击页面中的“立即抽生日礼物”，即可进行生日抽奖。“生日专属好礼”指通过京东生日礼许愿玩法，收集并抽奖赢取的心愿礼品，具体抽取的京东生日礼，以用户中奖界面实际展示为准。当用户点击生日抽奖按钮后，会展示二次确认弹窗，确认用户即将抽奖的许愿池礼品内容。请注意，一旦点击“确认抽奖”，将无法再退回页面进行新的心愿礼品收集或者编辑奖池。抽奖后，未放入许愿池的心愿礼品、以及未抽中的心愿礼品将无法再次查看。";
        let levelListRule = this.levelList.map(item=>item.name);
        const {firstTextStr,precautions} = this.getCommonText(levelListRule,this.ruleForm,this.ruleDto,2,false);
        let secondTextStr = "\n二、【如何获奖】";
        let thirdTextStr = "\n\n三、【活动奖品】";
        let fourthTextStr = `\n\n四、【注意事项】\n1.${ precautions }`
      // 领奖有效期
      if (this.ruleForm.timeType) {
        const obj = this.brithdayList.find(item=>item.value == this.ruleForm.timeType)
        text4 = `\n1.领奖有效期：${obj.label}可领取奖励，过期视作放弃领取；`;
      }
      if(this.ruleDto.activityMode == 0){
        secondTextStr += text4 + text6;
      }else{
        secondTextStr += text4 + text7;
      }
      if(this.ruleDto.activityMode == 0) {
        // 奖品设置
        if (this.ruleForm.settingType == 1) {
          let listArrStr = "";
          const circleNums = ["①", "②", "③", "④", "⑤", "⑥", "⑦", "⑧", "⑨", "⑩"];
          if (this.getChooseLevel && this.getChooseLevel.length) {
            this.getChooseLevel.forEach((levelItem, index) => {
              const item = this.prizeSettingListLevel.find(p => p.customerLevel == levelItem.value);
              if (item && item.settingList && item.settingList.length) {
                const hasValidPrizes = item.settingList.some(list => list.title);
                if (hasValidPrizes) {
                  let num = circleNums[index] ? circleNums[index] : (index + 1) + ".";
                  listArrStr += `\n${num}${levelItem.name}：`;
                  item.settingList.forEach((list, idx) => {
                    if (list.title) {
                      if(list.prizeType == 3){
                        listArrStr += `\n（${idx + 1}）奖品${idx + 1}：${list.title}，共 ${list.totalAmount} 份，单份奖品价值 ${list.price} 元；`;
                      }else {
                        listArrStr += `\n（${idx + 1}）奖品${idx + 1}：${list.title}，共 ${list.totalAmount} 份；`;
                      }
                    }
                  });
                }
              }
            });
          }
          if (listArrStr) {
            text5 = listArrStr;
          }
          thirdTextStr += "\n1.活动奖品：按当前会员等级，选其一奖品领取" + text5;
        } else {
          let listArrStr = "";
          if (this.prizeSettingList && this.prizeSettingList.length) {
            this.prizeSettingList.filter(item => item.title).forEach((list, index) => {
              if(list.prizeType == 3){
                listArrStr += `\n（${index + 1}）奖品${index + 1}：${list.title}，共 ${list.totalAmount} 份，单份奖品价值${list.price}元；`;
              }else {
                listArrStr += `\n（${index + 1}）奖品${index + 1}：${list.title}，共 ${list.totalAmount} 份；`;
              }
            });
          }
          if (listArrStr) {
            text5 = listArrStr;
          }
          thirdTextStr += text5;
        }
      } else {
        this.giftSettingList.forEach((item, index) => {
          text1 += `（${index+1}）奖品${index+1}：${item.title}，共${item.totalAmount}份${item.prizeType==3 ? ('，单份奖品价值'+item.price+'元') : ''}；`
          if(index<this.giftSettingList.length-1) {
            text1 += `\n`
          }
        })
        thirdTextStr += text1 + "\n" +text2;
      }
      this.ruleForm.ruleDescription = firstTextStr + secondTextStr + thirdTextStr + fourthTextStr;
    },
    //清除
    cleanData(row) {
      if(this.activityData.isStart || this.backgroundOpacity)return;
      row.assetsId = null;
      row.prizeType = null;
      row.price = null;
      row.title = null;
      row.logo = null;
      row.percentage = "";
      row.singleAmount = null;
      row.totalAmount = null;
      row.shouldCollectExtraData = 0
      row.extraQuestion = null
    },
    //选择奖品弹窗
    centerVis(row) {
      this.JingdouCount.prizeCount = row.totalAmount;
      this.echoDate = row;
      this.isSelectProduct = true
      this.$nextTick(()=>{
        this.$refs.selectProduct.openDialog();
      })
    },
    // 关闭奖品弹窗
    productClose(){
      this.isSelectProduct = false
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      // this.$emit("returnBack");
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    // 获取奖品
    getTheData(data, prizeType) {
      this.echoDate.logo = data.logo;
      if (prizeType == 1) {
        this.echoDate.couponType = data.couponType;
      }
      if (data.giftType) {
        this.echoDate.giftType = Number(data.giftType);
      }
      this.echoDate.price = Number(data.discount);
      this.echoDate.assetsId = data.couponId || data.skuId ?  Number(data.couponId || data.skuId) : "";
      this.$set(this.echoDate, "logo", data.logo?data.logo:this.priceImg);
      this.echoDate.prizeType = prizeType;
      if (prizeType == 4) {
        this.echoDate.title = data.discount + "店铺积分";
      } else {
        this.echoDate.title = data.name;
      }
      if (data.singleAmount) {
        this.echoDate.singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        this.echoDate.quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        if(!data.isGoodManage) {
          this.echoDate.skuId = data.skuId;
          delete this.echoDate.isGoodManage
        } else {
          this.echoDate.isGoodManage = data.isGoodManage;
        }
        this.echoDate.isFollowActivityEndTime = data.isFollowActivityEndTime;
        this.echoDate.addressFillEndTime = data.addressFillEndTime;
        this.echoDate.predictSendTime = data.predictSendTime;
        this.echoDate.shouldCollectExtraData = data.shouldCollectExtraData; //是否需要额外信息
        this.echoDate.extraQuestion = data.extraQuestion; //额外问题
        this.echoDate.addressFillLimit = data.addressFillLimit;
        this.echoDate.commitAddressLimit = data.commitAddressLimit;
      }
      if(prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(this.echoDate,prizeType,data);
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8,10].includes(Number(prizeType))) {
        this.echoDate.budgetRemain = data.budgetRemain;
      }
      if(prizeType==3&&data.isGoodManage) {
        this.echoDate.budgetRemain = data.budgetRemain;
      }
      this.isSelectProduct = false
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },

    // 下一步
    resetForm() {
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      if (this.actMember == 3 && !this.peopleSelected.length) {
        this.$message.warning("请选择指定人群");
        return;
      }
      // 活动参与对象
      if (this.ruleForm.partner.length == 0) {
        this.$message.warning("请选择活动参与对象");
        return;
      }

      // 1.14迭代 这里判断
      // if(this.ruleDto.isCheckOpenCardTime&&(!this.ruleDto.openCardStartTime||!this.ruleDto.openCardEndTime)){
      //   return this.$message.warning("请选择入会时间");
      // }
      if (
        this.ruleForm.firstOpenCardTimeType == 1 &&
        (!this.ruleForm.openCardBeforeDay)
      ) {
        return this.$message.warning("请完善首次入会时间");
      }
      if (
        this.ruleForm.firstOpenCardTimeType == 2 &&
        (!this.ruleDto.openCardStartTime || !this.ruleDto.openCardEndTime)
      ) {
        return this.$message.warning("请完善首次入会时间");
      }
      if(this.birthdayReceiveLimitType==1) {
        if(this.ruleDto.birthdayReceiveLimitType==1) {
          if(!this.ruleDto.birthdayReceiveLimitStartDate||!this.ruleDto.birthdayReceiveLimitEndDate) {
            return this.$message.warning("请完善生日领奖限制时间");
          }
        }
      }
      if(this.ruleDto.activityMode==0) {
        // 请将奖品填写完整！
        let isFlay = false;
        // 统一设置
        if(this.ruleForm.settingType == 2){
          if(this.prizeSettingList.length == 0){
            isFlay = true;
          }
          
          this.prizeSettingList.forEach((item) => {
            if (item.prizeType != 9) {
              if (!item.totalAmount || !item.title) {
                isFlay = true;
              }
            }
          });
        }else{
          // 按等级
          this.prizeSettingListLevel.forEach((item) => {
            if(item.settingList.length == 0){
              isFlay = true;
            }
            item.settingList.forEach(list=>{
              if (list.prizeType != 9) {
                if (!list.totalAmount || !list.title) {
                  isFlay = true;
                }
              }
            })
          });
        }
        if (isFlay) {
          return this.$message.warning("请将奖品填写完整！");
        }
      } else {
        if(!this.ruleDto.collectNum) {
          return this.$message.warning("请输入许愿赠送收集次数");
        } 
        if(this.taskDataList.length == 0) {
          return this.$message.warning("请添加心愿收集任务");
        }
        if(this.giftSettingList.length>0) {
          let isFlag = this.giftSettingList.some((item)=>{
            return !item.title || !item.prizeType || !item.percentage
          })
          if(isFlag) {
            return this.$message.warning("请完善生日心愿礼品设置");
          }
        }

        if(this.ruleDto.isOpenPocket==1) {
          let isFlag2 = this.prizeList.some((item)=>{
            return !item.title || !item.prizeType
          })
          if(isFlag2) {
            return this.$message.warning("请完善兜底奖品设置");
          }
        }
        let isFlag3 = this.wishSetting.some((item)=>{
          return !item.wishName
        })
        if(isFlag3) {
          return this.$message.warning("请完善生日许愿标题");
        }
        if(!this.ruleForm.blessingText) {
          return this.$message.warning("请输入祝福文案");
        }
      }
      // 公活动配置校验
      if (!useValidateMoreActSet(this)) {
        return;
      }
      // 小程序分享标题
      if (!this.ruleForm.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleForm.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      if(this.placementPosition.length==0) {    
        this.$message.warning("请选择活动投放位置！");
        return
      }

      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft(){
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if(this.isDraftEdit){
        this.$confirm('是否保存对当前草稿的修改?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }else{
        this.$confirm('是否存为草稿?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }
    },
    async handleDialogCloseAnoth() {
      let obj = {};
      obj = this.deepClone(this.ruleForm);
      obj.ruleDTO = {
        taskList: [],
        birthWishTitle: [],
        birthdayReceiveLimitType: this.ruleDto.birthdayReceiveLimitType,
        birthdayReceiveLimitStartDate:this.ruleDto.birthdayReceiveLimitStartDate,
        birthdayReceiveLimitEndDate: this.ruleDto.birthdayReceiveLimitEndDate,
      };
      //领奖有效期
      obj.ruleDTO.awardValidity = this.ruleForm.timeType
      //奖品配置
      obj.ruleDTO.awardConfig = this.ruleForm.settingType
      //祝福文案
      if(this.ruleForm.blessingText){  
        obj.ruleDTO.content = this.ruleForm.blessingText
      }
      //关注店铺后方可参与互动
      obj.ruleDTO.requestFollow = this.ruleForm.condFollow
      // 分享
      obj.ruleDTO.shareTitle = this.ruleForm.shareTitle;
      obj.ruleDTO.shareIntroduce = this.ruleForm.shareIntroduce;
      obj.ruleDTO.sharePic = this.ruleForm.sharePic;
      
      // 奖品设置
      //进行中修改的名次奖品设置
      let prizes = []
      if(this.ruleDto.activityMode==0) {
        obj.ruleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork);
        if(this.ruleForm.settingType == 1){
          // 按等级
          obj.pointActivityPrizeDTOList = []
          this.prizeSettingListLevel.forEach(list=>{
            list.settingList.forEach(item=>{
              const itemObj = {
                ...item,
                taskIndex:list.customerLevel,
                title: item.title,
                assetsId: item.assetsId || "",
                prizeType: item.prizeType,
                logo: item.logo,
                discount: item.price || item.singleAmount,
                singleAmount: item.singleAmount,
                price: item.price,
                totalAmount: item.totalAmount,
                isFollowActivityEndTime: item.isFollowActivityEndTime,
                addressFillEndTime: item.addressFillEndTime,
                predictSendTime: item.predictSendTime,
                shouldCollectExtraData: item.shouldCollectExtraData, //是否需要额外信息
                extraQuestion: item.extraQuestion, //额外问题
                addressFillLimit: item.addressFillLimit,
                // 提交地址限制：数组转逗号分隔字符串
                commitAddressLimit: Array.isArray(item.commitAddressLimit) 
                  ? item.commitAddressLimit.join(',') 
                  : item.commitAddressLimit,
              }
              if (item.prizeType == 1) {
                itemObj.quota = item.quota;
                itemObj.couponType = item.couponType;
              }
              if (item.prizeType == 3) {
                if(item.isGoodManage==1) {
                  itemObj.isGoodManage = item.isGoodManage
                }
              }
              if(item.prizeType == 14 || item.prizeType == 1) {
                this.getPhysicalShipped(itemObj,item.prizeType,item);
              }
              obj.pointActivityPrizeDTOList.push(itemObj)
              // 进行中奖品份数数据
              if(this.activityData.isStart){
                prizes.push({
                  ...item,
                  prizeId:item.id,
                  totalAmount: item.totalAmount,
                  // 提交地址限制：数组转逗号分隔字符串
                  commitAddressLimit: Array.isArray(item.commitAddressLimit) 
                    ? item.commitAddressLimit.join(',') 
                    : item.commitAddressLimit,
                })
              }
            })
          })
        }else{
          obj.pointActivityPrizeDTOList = this.prizeSettingList.map(item=>{
            const obj = {
              ...item,
              title: item.title,
              assetsId: item.assetsId||"",
              prizeType: item.prizeType,
              logo: item.logo,
              discount: item.price || item.singleAmount,
              singleAmount: item.singleAmount,
              price: item.price,
              totalAmount: item.totalAmount,
              isFollowActivityEndTime: item.isFollowActivityEndTime,
              addressFillEndTime: item.addressFillEndTime,
              predictSendTime: item.predictSendTime,
              shouldCollectExtraData: item.shouldCollectExtraData, //是否需要额外信息
              extraQuestion: item.extraQuestion, //额外问题
              addressFillLimit: item.addressFillLimit,
              // 提交地址限制：数组转逗号分隔字符串
              commitAddressLimit: Array.isArray(item.commitAddressLimit) 
                ? item.commitAddressLimit.join(',') 
                : item.commitAddressLimit,
            }
            if (item.prizeType == 1) {
              obj.quota = item.quota;
              obj.couponType = item.couponType;
            }
            if (item.prizeType == 3) {
              if(item.isGoodManage==1) {
                obj.isGoodManage = item.isGoodManage
              }
            }
            if(item.prizeType == 14) {
              this.getPhysicalShipped(obj,item.prizeType,item);
            }
            // 进行中奖品份数数据
            if(this.activityData.isStart){
              prizes.push({
                ...item,
                prizeId:item.id,
                totalAmount: item.totalAmount,
                // 提交地址限制：数组转逗号分隔字符串
                commitAddressLimit: Array.isArray(item.commitAddressLimit) 
                  ? item.commitAddressLimit.join(',') 
                  : item.commitAddressLimit,
              })
            }
            return obj
          })
        }
      } else {
        // 任务设置
        if (this.taskDataList.length) {
          obj.ruleDTO.taskList = useInputTaskData(this.taskDataList);
        } else {
          obj.ruleDTO.taskList = [];
        }
        // 奖品设置
        let giftSettingLists = this.giftSettingList.map((item)=>{
          const prize = {
            ...item,
            prizeObjectType: 0,
          };
          // 提交地址限制：数组转逗号分隔字符串
          if (item.prizeType == 3 && Array.isArray(item.commitAddressLimit)) {
            prize.commitAddressLimit = item.commitAddressLimit.join(',');
          }
          return prize;
        });
        if(this.ruleDto.isOpenPocket==1) {
          let prizeLists = this.prizeList.map((item)=>{
            const prize = {
              ...item,
              prizeObjectType: 1,
            };
            // 提交地址限制：数组转逗号分隔字符串
            if (item.prizeType == 3 && Array.isArray(item.commitAddressLimit)) {
              prize.commitAddressLimit = item.commitAddressLimit.join(',');
            }
            return prize;
          })
          giftSettingLists = giftSettingLists.concat(prizeLists)
        }
        obj.pointActivityPrizeDTOList = giftSettingLists
        if(this.activityData.isStart){
          giftSettingLists.forEach(item=>{
            let prize = {
              ...item,
              prizeId:item.id,
              totalAmount: item.totalAmount,
              prizeObjectType: item.prizeObjectType,
            }
            if(item.prizeObjectType==1) {
              prize.logo = item.logo
            }
            prizes.push(prize)
          })
        }
        // 生日许愿标题
        obj.ruleDTO.birthWishTitle = this.wishSetting.map((item)=>item.wishName);
        obj.ruleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork);
      }
      obj.templateJson = this.templateJson; //多个模板
      if (this.actMember == 1) {
        obj.allowLevel = "-1";
      } else if (this.actMember == 3) {
        obj.allowLevel = "99";
        obj.crowdIds = this.peopleSelected.join(",");
      } else if (this.actMember == 2) {
        obj.allowLevel = this.ruleForm.partner.join(",");
        if (obj.allowLevel == "-1") {
          //会员等级设置
          let list = ["-1", "0"];
          this.levelList.forEach((item, index) => {
            let num = index + 1;
            list.push(num);
          });
          obj.allowLevel = list.join(",");
        }
      }
      // 1.14迭代 这里提交
      if(obj.allowLevel != "-1" && obj.allowLevel != "99") {
        obj.ruleDTO.isCheckOpenCardTime = this.ruleDto.isCheckOpenCardTime
        obj.ruleDTO.openCardStartTime = this.ruleDto.openCardStartTime
        obj.ruleDTO.openCardEndTime = this.ruleDto.openCardEndTime
        obj.ruleDTO.plusObject = this.ruleDto.plusObject
        obj.ruleDTO.firstOpenCardTimeType = this.ruleForm.firstOpenCardTimeType
      }
      obj.ruleDTO.birthdayInfoType = this.ruleDto.birthdayInfoType || 1
      obj.ruleDTO.cusTemplateJSON = this.ruleDto.cusTemplateJSON
      obj.ruleDTO.isForceRemind = this.ruleDto.isForceRemind
      // 是否重点活动
      obj.isKeyActivity = this.isKeyActivity
      // 活动投放位置
      obj.placementPosition = this.placementPosition.join(",")
      obj.ruleDTO.openCardBeforeDay = this.ruleForm.openCardBeforeDay
      obj.ruleDTO.openCardFollow = this.ruleForm.openCardFollow
      obj.ruleDTO.activityMode = this.ruleDto.activityMode
      obj.ruleDTO.collectNum = this.ruleDto.collectNum
      obj.ruleDTO.isOpenPocket = this.ruleDto.isOpenPocket
      obj.priceType = 0;
      obj.isExposureItem = this.ruleForm.exposureSwitch ? 1 : 0;
      obj.itemList = this.itemListFor; //曝光商品集合
      obj.templateId = this.templateId;

      // V2.5 => 复制，去除id和旧的模板数据
      if (this.activityData.isCopy) {
        this.ids = "";
        delete obj.templateJson;
      }
      if (this.checked == true || this.isDraft) {
        if (this.ids == "" || this.isDraft || this.isDraftEdit) {
          // 草稿箱
          if(this.isDraft){
            obj.status = 5
            // 草稿箱奖品填写完整校验-若不全则为空
            obj.pointActivityPrizeDTOList = obj.pointActivityPrizeDTOList.filter(item=>item.prizeType)
          }
          // 草稿箱编辑-添加活动id
          if(this.isDraftEdit){
            obj.id = this.valueRow.id
          }
          if(this.activityData.isCopy){
            delete obj.id
          }
          createBirthDayGift(obj)
            .then((res) => {
              if (res && res.code == 1) {
                if(this.isDraft){
                  this.$message.success("保存成功！")
                  this.$emit("returnBack",true);
                }else{
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {});
        } else {
          delete obj.templateJson;
          let res;
          if (this.activityData.isStart) {
            let params = {
              activityName: obj.activityName,
              activityId: this.ids,
              ruleDescription: obj.ruleDescription,
              prizes: obj.pointActivityPrizeDTOList.filter((item) => item.id)
              .map((item) => {
                return {
                  ...item,
                  prizeId: item.id,
                };
              }),
              isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
              itemList: this.itemListFor,
              ruleDto: obj.ruleDTO,
              templateId: this.templateId,
              taskList: obj.ruleDTO.taskList,
              isValidBlackList: this.ruleForm.isValidBlackList,
              activityName: this.ruleForm.activityName,
            };
            if(this.actEndTime!=this.activityEndTime) {
              params.endTime = this.activityEndTime
            }
            res = await updateCommon(params);
          } else {
            // 修改添加主键id
            obj.pointActivityId = this.ids
            res = await updateBirthDayGift(obj);
          }
          if (res && res.code == 1) {
            this.joinBlackList = false;
            this.$router.push({
              name: "throw",
              query: {
                id: res.data.id,
                activityType: res.data.activityType,
              },
            });
            this.$message.success(res.message);
          } else {
            if (res.message) {
              this.$message.error(res.message);
            } else {
              this.$message.error(res.data.message);
            }
          }
        }
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.ids != "") {
        let id = this.ids;
        this.valueRow = {
          id: id,
        };
        this.loading = true
        getBirthDayDetail(id)
          .then((res) => {
            this.loading = false
            // 活动名称
            this.ruleForm.activityName = res.data.activityName + (this.activityData.isCopy?"复制":"");
            // 会员
            this.ruleForm.partner = res.data.allowLevel.split(",");
            if (res.data.allowLevel == "99") {
              this.peopleSelected = res.data.crowdIds.split(",");
              this.actMember = "3";
            } else if (res.data.allowLevel == "-1") {
              this.actMember = "1";
            } else {
              this.actMember = "2";
              if (res.data.allowLevel.indexOf("-1") != -1) {
                this.ruleForm.partner = ["-1"];
              }
            }
            this.isKeyActivity = res.data.isKeyActivity || 0, // 是否重点活动
            this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(",") : ["SHOP"], // 活动投放位置
            // 1.14迭代 这里回显
            this.ruleDto={
              isCheckOpenCardTime:res.data.ruleDto.isCheckOpenCardTime,
              openCardStartTime:res.data.ruleDto.openCardStartTime,
              openCardEndTime:res.data.ruleDto.openCardEndTime,
              plusObject:res.data.ruleDto.plusObject, //plus会员
              birthdayInfoType: res.data.ruleDto.birthdayInfoType || 1, // 生日信息获取类型
              cusTemplateJSON: res.data.ruleDto.cusTemplateJSON, // 自定义背景图
              isForceRemind: res.data.ruleDto.isForceRemind, // 是否强制提醒
              activityMode: res.data.ruleDto.activityMode ? res.data.ruleDto.activityMode : 0,//领奖模式
              collectNum: "",//收集次数
              isOpenPocket: 1, //是否开启兜底奖品设置
              birthdayReceiveLimitType: res.data.ruleDto.birthdayReceiveLimitType || 0, //生日领奖限制类型
              birthdayReceiveLimitStartDate: res.data.ruleDto.birthdayReceiveLimitStartDate || "", //生日领奖限制开始时间
              birthdayReceiveLimitEndDate: res.data.ruleDto.birthdayReceiveLimitEndDate || "", //生日领奖限制结束时间
            }
            if(!res.data.ruleDto.birthdayReceiveLimitType) {
              this.birthdayReceiveLimitType = 0
            } else {
              this.birthdayReceiveLimitType = 1
            }
            this.ruleForm.firstOpenCardTimeType = res.data.ruleDto.firstOpenCardTimeType !==null ? res.data.ruleDto.firstOpenCardTimeType : 0
            if(this.ruleDto.openCardStartTime&&this.ruleDto.openCardEndTime) {//兼容京获客firstOpenCardTimeType为null回显
              this.ruleForm.firstOpenCardTimeType = 2
            }
            this.ruleForm.openCardBeforeDay = res.data.ruleDto.openCardBeforeDay
            this.ruleForm.openCardFollow = res.data.ruleDto.openCardFollow==1 ? 1 : 0
            // 模板
            this.templateId = res.data.templateId;
            // 关注店铺后方可参与互动
            this.ruleForm.condFollow = res.data.ruleDto.requestFollow
            // 分享
            this.ruleForm.shareTitle = res.data.ruleDto.shareTitle;
            this.ruleForm.shareIntroduce = res.data.ruleDto.shareIntroduce;
            this.ruleForm.sharePic = res.data.ruleDto.sharePic;
            // 黑名单
            this.ruleForm.isValidBlackList = res.data.isValidBlackList;
            // 学生身份
            this.ruleForm.studentSatus = res.data.studentSatus || "";
            // 领奖有效期
            this.ruleForm.timeType = res.data.ruleDto.awardValidity

            //祝福文案
            if(res.data.ruleDto.content){  
              this.ruleForm.blessingText = res.data.ruleDto.content
            }
            if(res.data.ruleDto.customerPaperwork) {
              this.customerPaperwork = JSON.parse(res.data.ruleDto.customerPaperwork)
            }
            if(this.ruleDto.activityMode == 1){
              this.ruleDto.collectNum = res.data.ruleDto.collectNum;
              this.ruleDto.isOpenPocket = res.data.ruleDto.isOpenPocket;
              if(res.data.ruleDto.customerPaperwork) {
                this.customerPaperwork = JSON.parse(res.data.ruleDto.customerPaperwork)
              } else {
                this.isCustomerNull = true
              }
              this.wishSetting = res.data.ruleDto.birthWishTitle.map((item)=>{
                return {
                  wishName: item
                }
              })
              let taskList = res.data.ruleDto.taskList
              // 任务回显
              if (taskList.length > 0) {
                this.taskDataList = this.taskDataList = useOutputTaskData(taskList, this);
              }
            }
            // v2.5 => 复制不需要回显奖品和规则
            if (!this.activityData.isCopy) {
              // 规则
              this.ruleForm.ruleDescription = res.data.ruleDescription
              if(this.ruleDto.activityMode == 1){
                let prizeLists = res.data.pointActivityPrizeDTOList
                this.giftSettingList = prizeLists.length > 0 ? prizeLists.filter((item)=>{
                  return item.prizeObjectType == 0
                }).map(item => {
                  // 提交地址限制回显：逗号分隔字符串转数字数组
                  if (item.prizeType == 3) {
                    if (item.commitAddressLimit) {
                      item.commitAddressLimit = typeof item.commitAddressLimit === 'string'
                        ? item.commitAddressLimit.split(',').map(Number)
                        : item.commitAddressLimit;
                    } else {
                      item.commitAddressLimit = [0];
                    }
                  }
                  return item;
                }) : this.giftSettingData;
                let prizeList = prizeLists.length > 0 ? prizeLists.filter((item)=>{
                  return item.prizeObjectType == 1
                }).map(item => {
                  // 提交地址限制回显：逗号分隔字符串转数字数组
                  if (item.prizeType == 3) {
                    if (item.commitAddressLimit) {
                      item.commitAddressLimit = typeof item.commitAddressLimit === 'string'
                        ? item.commitAddressLimit.split(',').map(Number)
                        : item.commitAddressLimit;
                    } else {
                      item.commitAddressLimit = [0];
                    }
                  }
                  return item;
                }) : [{
                      assetsId: null, // 资产项id(计划id优惠卷id商品id)
                      prizeType: null,
                      price: null,
                      logo: null,
                      title: "",
                      totalAmount: null,
                      singleAmount: "",
                      prizeObjectType: 1,
                    }];
                if(prizeList.length > 0) {
                  this.prizeList = prizeList
                } 
              } else {
                //奖品配置
                this.ruleForm.settingType = res.data.ruleDto.awardConfig
                // 按等级
                if(res.data.pointActivityPrizeDTOList && res.data.pointActivityPrizeDTOList.length){
                  if(res.data.ruleDto.awardConfig == 1){
                    // 全部
                    let levelArr = []
                    if(this.ruleForm.partner.includes("-1")){
                      levelArr = this.levelList
                    }else{
                      levelArr = this.levelList.filter(item=>this.ruleForm.partner.includes(item.value))
                    }
                    this.prizeSettingListLevel = levelArr.map((item) => {
                      const obj = {
                        customerLevel:item.value,
                        name: item.name,
                        settingList: [],
                      }
                      res.data.pointActivityPrizeDTOList.forEach(list=>{
                        if(item.value == list.taskIndex){
                          // 提交地址限制回显：逗号分隔字符串转数字数组
                          if (list.prizeType == 3) {
                            if (list.commitAddressLimit) {
                              list.commitAddressLimit = typeof list.commitAddressLimit === 'string'
                                ? list.commitAddressLimit.split(',').map(Number)
                                : list.commitAddressLimit;
                            } else {
                              list.commitAddressLimit = [0];
                            }
                          }
                          obj.settingList.push({...list,minNum:item.totalAmount})
                        }
                      })
                      return obj
                    });
                  }else{
                    // 统一设置
                    this.prizeSettingList = res.data.pointActivityPrizeDTOList.map(item=>{
                      item.minNum = item.totalAmount
                      const prizeItem = { ...item };
                      // 提交地址限制回显：逗号分隔字符串转数字数组
                      if (item.prizeType == 3) {
                        if (item.commitAddressLimit) {
                          prizeItem.commitAddressLimit = typeof item.commitAddressLimit === 'string'
                            ? item.commitAddressLimit.split(',').map(Number)
                            : item.commitAddressLimit;
                        } else {
                          prizeItem.commitAddressLimit = [0];
                        }
                      }
                      return prizeItem;
                    })
                  }
                }
              }
              // 曝光商品
              this.ruleForm.radio = res.data.priceType; // 0：显示京东价 1：显示促销价 ,
              this.ruleForm.exposureSwitch =
                res.data.isExposureItem == 0 ? false : true;
              this.selectGoodsArr = res.data.itemList;
              this.mainImagelist = res.data.itemList;
              this.itemListFor = res.data.itemList;
            } else {
              if(res.data.ruleDto.awardConfig == 1){
                  // 全部
                  let levelArr = []
                  if(this.ruleForm.partner.includes("-1")){
                    levelArr = this.levelList
                  }else{
                    levelArr = this.levelList.filter(item=>this.ruleForm.partner.includes(item.value))
                  }
                  this.prizeSettingListLevel = levelArr.map((item) => {
                    const obj = {
                      customerLevel:item.value,
                      name: item.name,
                      settingList: [
                      {
                        assetsId: null,
                        prizeType: null,
                        price: null,
                        totalAmount: null,
                        percentage: null,
                      },
                      ],
                    }
                    return obj
                  });
                }
            }
            this.getPolite()
            this.templateJson = JSON.parse(res.data.templateJson);
            this.activityStartTime = res.data.startTime?res.data.startTime:null
            this.activityEndTime = res.data.endTime?res.data.endTime:null
            this.actEndTime = res.data.endTime;
            this.activityTimeChange();
          })
          .catch((res) => {
            this.loading = false
          });
      } else {
        // 新增-默认活动时间
        if(!this.valueRow){
          this.activityStartTime = this.$getDate(30)[0]
          this.activityEndTime = this.$getDate(30)[1]
        }
        this.activityTimeChange();
      }
    },
    //清空时间
    clearTime() {
      this.ruleForm.startTime = "";
      this.ruleForm.endTime = "";
      this.activityStartTime = null
      this.activityEndTime = null
    },
    // 活动时间改变
    activityTimeChange() {
      this.ruleForm.startTime = this.activityStartTime;
      this.ruleForm.endTime = this.activityEndTime;
      this.$nextTick(() => {
        if(this.ruleForm.endTime && this.ruleForm.startTime){
          let nowTime = new Date().getTime();
          let start = new Date(this.ruleForm.startTime).valueOf();
          let end = new Date(this.ruleForm.endTime).valueOf();
          let invalidateDate = new Date(this.$store.getters.pointUserInfo.expiredIn).valueOf();
          let hdInvalidateDate = new Date(this.$store.getters.loginUserInfo.expiresIn).valueOf();
          this.timeDay = Math.floor(
            Math.abs(
              new Date(this.ruleForm.endTime) -
                new Date(this.ruleForm.startTime)
            ) /
              1000 /
              60 /
              60 /
              24
          );
          //计算小时
          const date3 = new Date(this.ruleForm.endTime).getTime() - new Date(this.ruleForm.startTime).getTime();
          const leave1 = date3 % (24 * 3600 * 1000);
          this.timeOut = Math.floor(leave1 / (3600 * 1000));
          // 查看不需要校验
          if(!this.backgroundOpacity){
            if (start < nowTime) {
              if (this.ids) {
                this.disableTime = true;
              } else {
              }
            }
            if (end < nowTime) {
              this.$message.warning("结束时间不能小于当前时间");
            }
            if (end < start) {
              this.$message.warning("结束时间不能小于开始时间");
              return;
            }
            if (end > invalidateDate) {
              this.$message.warning("活动时间不能超过软件有效期，请重新选择");
              this.activityEndTime = null;
              this.ruleForm.endTime = null;
              return;
            }
            if (end > hdInvalidateDate) {
              this.$message.warning("活动时间不可超过互动数据授权有效期！");
              this.activityEndTime = null;
              this.ruleForm.endTime = null;
              return;
            }
          }
        }
      });
    },

    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if(!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    levelClick(index) {
      this.levelIndex = index;
    },
    //上传图片前校验  奖品图片设置
    beforeUpload2(file) {
      let _this = this;
      const isSize = new Promise((resolve, reject) => {
        let width = 300;
        let height = 300;
        var _URL = window.URL || window.webkitURL;
        var img = new Image();
        img.onload = function() {
            let valid = width === this.width  && height === this.height;
            valid ? resolve() : reject(this);
            _this.uploadSize = valid;
        }
        img.src = _URL.createObjectURL(file);
      }).then(()=>{
        return file
      },()=>{
        this.$message.info("奖品展示图片尺寸不符合要求,请重新上传");
        return Promise.reject()
      })
      // 校验尺寸和类型
      const isLt3M = file.size < 300 * 1024;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      const isType = sorts.includes(type)
      if (!isLt3M) {
        this.$message.info("奖品展示图片大小不符合要求,请重新上传");
      }
      if (!isType) {
        this.$message.info("奖品展示图片格式不符合要求,请重新上传");
      }
      return isLt3M && isType && isSize
    },
    // 上传成功  奖品图片设置
    handleUpload2(res, scope) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        console.log(this.uploadSize)
        console.log(res.data)
        if (this.uploadSize) {
          this.$set(scope.row,'logo',res.data)
        }
      }
    },
    // 添加奖项-会员
    addSetting(item) {
      if (item.settingList.length > 3)
        return this.$message.warning("最多只能设置4个奖品");
      item.settingList.push({
        prizeType: null,
        price: null,
        totalAmount: null,
        percentage: null,
      });
    },
    // 添加奖项
    addSettingAll() {
      if (this.prizeSettingList.length > 3)
        return this.$message.warning("最多只能设置4个奖品");
      this.prizeSettingList.push({
        prizeType: null,
        price: null,
        totalAmount: null,
        percentage: null,
      });
    },
    // 删除
    deleteSetting(index, item) {
      // 会员
      if (item) {
        item.settingList.splice(index, 1);
      } else {
        this.prizeSettingList.splice(index, 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.titleBox){
  margin: 16px 0;
}
.prosi {
  position: absolute;
  bottom: 107px;
  right: 38px;
}
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
    }
  }
  .firststep {
    box-sizing: border-box;
    padding: 35px 35px 0;
    .itemList {
      display: flex;
      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #2768ff;
            border-bottom: 1px solid #2768ff;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #2768ff;
            border-left: 1px solid #2768ff;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          width: 206px;
          &:hover {
            .mask {
              opacity: 1;
            }
          }
          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 4px;
                opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    margin-bottom: 29px;
    .zd {
      width: 360px;
    }
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .limit {
      display: flex;
      flex-direction: column;
      p {
        margin: 0;
        &:nth-child(2) {
          margin: 16px 0;
        }
      }
      .c {
        color: #2768ff;
      }
      .desc {
        i {
          opacity: 0.7;
          color: #2768ff;
        }
        color: #999;
      }
      /deep/ .el-input {
        margin: 0 6px;
      }
    }
    .img {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #eeeeee;
    }
    .tips {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      box-sizing: border-box;
      padding: 13px 30px;
      background: #fffaee;
      font-size: 13px;
      color: #333;
      i {
        color: #fe8f8a;
        opacity: 0.7;
      }
      p {
        margin: 0;
        line-height: 20px;
        padding-left: 18px;
      }
    }
    .generate {
      width: 76px;
      margin-top: 8px;
      background: rgba(127, 133, 233, 0.1);
      border: 1px solid rgba(127, 133, 233, 1);
      color: #7f85e9;
    }
    .termAdd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      color: #333;
      p {
        margin: 0;
      }
      .add {
        margin-left: 4px;
        color: #2768ff;
      }
    }
    .set {
      display: inline-block;
      // margin-top: 30px;
    }
    .desc {
      margin-left: 20px;
      color: #999;
      font-size: 13px;
      i {
        color: #fe8f8a;
        opacity: 0.7;
        font-size: 13px;
      }
    }
    .s {
      color: #2768ff;
      cursor: pointer;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid #2768ff;
      color: #2768ff;
      transition: all 0.2s;
      &:hover {
        background-color: #2768ff;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #2768ff;
      color: #fff;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
.wrapper-kaika {
  width: 100%;
  height: 100%;
  display: grid;
  // align-items: center;
  // justify-content: center;

  &-img {
    background-color: #fafafa;
    border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
    border-radius: 8px;
    height: 350px;
    // margin-right: 20px;
    position: relative;
    &:hover {
      .borderkaika::before,
      .borderkaika::after {
        opacity: 1;
        transform: scale(1);
      }
    }
    .borderkaika {
      position: absolute;
      left: -6px;
      top: -6px;
      width: 218px;
      height: 360px;
      border-radius: 4px;
      &::before,
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: "";
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.8s, transform 0.8s;
        border-radius: 4px;
      }
      &::before {
        border-top: 1px solid #2768ff;
        border-bottom: 1px solid #2768ff;
        -webkit-transform: scale(0, 1);
        transform: scale(0, 1);
      }
      &::after {
        border-right: 1px solid #2768ff;
        border-left: 1px solid #2768ff;
        -webkit-transform: scale(1, 0);
        transform: scale(1, 0);
      }
    }

    div {
      font-size: 18px;
      font-weight: bold;
      // line-height: 25px;
      color: #333333;
    }
    img {
      width: 32px;
      height: 32px;
    }

    .queryIdIMG {
      display: none;
    }
    &:hover {
      .queryIdIMG {
        display: block;
      }
      .mask {
        opacity: 1;
      }
    }
    .mask {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      opacity: 0;
      transition: all 0.2s;
      .img {
        max-width: 130px;
        margin: 0 auto 30px;
        .imgBg {
          box-sizing: border-box;
          height: 129px;
          width: 129px;
          padding: 6px;
          border-radius: 6px;
          background-color: #fff;
        }
        .tpl {
          display: inline-block;
          font-size: 14px;
          color: #fff;
          margin-top: 10px;
          // opacity: 0.7;
        }
      }
    }
  }
  &-tanchuang {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .lijijq {
    &::after {
      content: "立即领取";
      display: block;
      position: absolute;
      bottom: 9px;
      left: 51%;
      transform: translateX(-50%);
      font-size: 14px;
      // font-family: system-ui;
      font-family: PingFang SC;
      font-weight: bold;
      color: #ed6e09;
      text-shadow: 0 0 black;
    }
  }
}
.miniAppPic {
  position: relative;
  .image-slot {
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;
    i {
      font-size: 30px;
      color: #909399;
    }
  }
  .top {
    position: relative;
    display: flex;
    left: 0;
    .returnBtn {
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color: #2768ff;
      background: rgba(123, 97, 255, 0.1);
      border: 1px solid #2768ff;
      &:hover {
        color: #fff;
        background: #2768ff;
      }
    }
    .reset {
      color: #2768ff;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;
    }
  }
  .bottom {
    position: relative;
    top: 15px;
    .elImg {
      width: 120px;
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }
    .tips1 {
      position: absolute;
      left: 135px;
      top: 22px;
      line-height: 2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
}
.setting-tip {
  margin: 0px 0px 20px 0px;
  &-red {
    color: red;
  }
  &-last-wrap {
    line-height: normal;
  }
}
.setting-radio {
  margin-bottom: 20px;
}
.setting-level {
  display: flex;
  align-items: center;
  &-item {
    width: 125px;
    text-align: center;
    background-color: #e9effc;
    &__active {
      color: #fff;
      background-color: #2768ff;
    }
  }
}
.btn-wrap {
  display: flex;
  align-items: center;
}
.add_btn1 {
  cursor: pointer;
  color: #2768ff;
  border: 1px solid #2768ff;
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(123, 97, 255, 0.1);
  border-radius: 4px;
  margin-top: 8px;
}
.del_box {
  position: absolute;
  left: 180px;
  top: 12px;
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68) !important;
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
  // display: none;
}
/deep/ .el-table__row:hover {
  .delQx {
    display: flex;
  }
}
.margin-t16{
  margin-top: 16px;
}

.rule-tip {
  margin-top: 8px;
}
.act-tip {
  white-space: nowrap;
  color: #ff0000;
}

.award-text {
  line-height: normal;
}

.input-style {
  width: 90px;
}
.text-style {
  margin-left: 8px;
  color: #666666;
}
.tip-color {
  margin-left: 8px;
  color: #FF8E0C;
}

.red-text {
  color: #ff0000;
}

.setting-box {
  width: 1000px;
}

.btn-bg{
  background: #f4f6fa;
  padding: 16px 16px 16px 0;
  width: fit-content;
}
.buttonGroup {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #666;
}
.birthday_receive_limit {
  display: flex;
  flex-direction: column;
}
</style>
<style lang="scss">
.createPlayStep {
  // .el-step.is-horizontal .el-step__line {
  //   height: 1px;
  // }
  // .el-step__head.is-success {
  //   color: #2768ff;
  //   border-color: #2768ff;
  //   .el-step__line {
  //     background-color: #2768ff;
  //   }
  // }
  // .el-step__head.is-process {
  //   color: #2768ff;
  //   border-color: #2768ff;
  // }
  // .el-step__title.is-process {
  //   color: #2768ff;
  // }
  // .el-step__title.is-success {
  //   color: #2768ff;
  // }
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
</style>
